import styled from "@emotion/styled";
import { numberFormatInt } from "utils/nuberFormat";
import { sd } from "../tokens";

interface DeltaTextProps {
  value: number;
  /** pct = "18.4%" | count = "12 รายการ" */
  mode?: "pct" | "count";
  /** หน่วยต่อท้ายเมื่อ mode = count */
  unit?: string;
  caption?: string;
}

/** ↗ 18.4% จากช่วงก่อนหน้า — เขียวเมื่อบวก แดงเมื่อลบ เทาเมื่อเท่าเดิม */
const DeltaText = ({ value, mode = "pct", unit = "รายการ", caption = "จากช่วงก่อนหน้า" }: DeltaTextProps) => {
  const safe = Number.isFinite(value) ? value : 0;
  const tone = safe > 0 ? sd.green : safe < 0 ? sd.red : sd.subtle;
  const arrow = safe > 0 ? "↗" : safe < 0 ? "↘" : "→";
  const amount =
    mode === "pct"
      ? `${Math.abs(safe).toFixed(1)}%`
      : `${numberFormatInt(Math.abs(safe))} ${unit}`;

  return (
    <Wrapper>
      <Value color={tone}>
        {arrow} {safe > 0 && mode === "count" ? "+" : ""}
        {amount}
      </Value>
      {caption ? <Caption>{caption}</Caption> : null}
    </Wrapper>
  );
};

export default DeltaText;

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 6px;
  flex-wrap: wrap;
`;

const Value = styled.span<{ color: string }>`
  font-size: 13px;
  font-weight: 600;
  color: ${(p) => p.color};
  white-space: nowrap;
`;

const Caption = styled.span`
  font-size: 12px;
  color: ${sd.subtle};
  white-space: nowrap;
`;
